import axiosInstance from ".";

export const getHome = () => {
  return axiosInstance.get("/home");
};

export const updateHome = (data) => {
  return axiosInstance.post("/home", data);
};